import { Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from 'react';
import CusColorPicker from '../../../../../components/material-ui/CusColorPicker';
import useNumberParams from '../../../../../hooks/useNumberParams';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import { API_CASINO } from '../../../../../api/casino';
import useToast from '../../../../../hooks/useToast';

export default function ColorContent() {
  const casinoId = useNumberParams('casinoId');
  const { successToast } = useToast();
  const [colorInfo, setColorInfo] = useState({ logo: '', header: '', button: '', bkg: '' });
  const gridSize = { xs: 12, sm: 6 };

  useEffect(() => {
    API_CASINO.color
      .get({ casinoId })
      .then((e) => {
        const data = e.data;
        setColorInfo(data.colorList);
      })
      .catch(console.error);
  }, [casinoId]);

  const onSaveClick = () => {
    console.log('colorInfo', colorInfo);
    API_CASINO.color
      .set({ casinoId, colorList: colorInfo })
      .then((e) => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  return (
    <Stack gap={2}>
      <Grid gap={1} spacing={1} container>
        <CusColorPicker
          size={gridSize}
          label={'Logo color'}
          value={colorInfo.logo}
          onChange={(val) => setColorInfo((prev) => ({ ...prev, logo: val }))}
        />
        <CusColorPicker
          size={gridSize}
          label={'Title color'}
          value={colorInfo.header}
          onChange={(val) => setColorInfo((prev) => ({ ...prev, header: val }))}
        />
        <CusColorPicker
          size={gridSize}
          label={'Button color'}
          value={colorInfo.button}
          onChange={(val) => setColorInfo((prev) => ({ ...prev, button: val }))}
        />
        <CusColorPicker
          size={gridSize}
          label={'Background color'}
          value={colorInfo.bkg}
          onChange={(val) => setColorInfo((prev) => ({ ...prev, bkg: val }))}
        />
      </Grid>

      <CasinoBtnSave onClick={onSaveClick} />
    </Stack>
  );
}
